import {
	ICrmeLeadTarefaTipoCleanDTO,
	ICrmeLeadTarefaTipoDTO,
	ICrmeLeadTarefaTipoFullDTO
} from '../models/happy-code-api.model';
import { baseFindList } from './base/base-find-list.service';

export const useLeadTarefaTipoService = () => {
	const resourceURL = 'crme/lead-tarefa-tipo';

	return {
		...baseFindList<ICrmeLeadTarefaTipoCleanDTO, ICrmeLeadTarefaTipoDTO, ICrmeLeadTarefaTipoFullDTO>(resourceURL),
	};
};
